import { GoogleOAuthProvider } from '@react-oauth/google'
import React, { Fragment } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { UserProvider } from './Context/UserDetailContext'
import ApplicationRoutes from './routes/applicationRoutes'
import { SnackbarProvider } from './GlobalComponent/GlobalSnackbar/GlobalSnackbar'
import { ProfileProvider } from './Context/ProfileDetailsContext'
import { AgentProvider } from './Context/AgentDetailsContext'
import { AdminDashboardProvider } from './Context/AdminDetailsContext'
import { TrainingProvider } from './Context/TrainingPageContext'

const App = () => {
    const CLIENT_ID = "588013271964-vpgtgb7s5r8udsd7j06t4gtlhr9rhab7.apps.googleusercontent.com";
    return (
        <>
            <Fragment>
                <GoogleOAuthProvider clientId={CLIENT_ID}>
                    <BrowserRouter>
                        <AdminDashboardProvider>
                            <AgentProvider>
                                <ProfileProvider>
                                    <SnackbarProvider>
                                        <UserProvider>
                                            <TrainingProvider>
                                                <ApplicationRoutes />
                                            </TrainingProvider>
                                        </UserProvider>
                                    </SnackbarProvider>
                                </ProfileProvider>
                            </AgentProvider>
                        </AdminDashboardProvider>
                    </BrowserRouter>
                </GoogleOAuthProvider>
            </Fragment>

        </>
    )
}

export default App